import { useAppSelector } from "../../../../../app/store";
import CustomPagination from "../../../../../components/ui/CustomPagination";
import Loader from "../../../../../components/ui/Loader";
import { useGetUserDetailsLogQuery } from "../../../../../features/emp-setting/employee/employeeApi";
import useTable from "../../../../../hooks/useTable";
import { formatDate, formatTime } from "../../../../../lib/time";

export default function ActivityLog() {
  const { user } = useAppSelector((state) => state.auth);
  const { filter, page, handlePagination, limit } = useTable<{
    page: number;
    limit: number;
    skip: number;
  }>();
  const { data: activityData, isLoading } = useGetUserDetailsLogQuery(
    {
      params: {
        business_member_id: user?.data?.id,
        // business_member_id: authInfo?.id,

        page,
        limit,
      },
    },
    { skip: !user?.data?.id }
    // { skip: !authInfo?.id }
  );
  const logs = activityData?.data?.logs;

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="">
        {logs?.map((val, index) => (
          <div key={index} className="relative pl-6 pb-4">
            {logs?.length - 1 === index ? null : (
              <div className="absolute left-[4px] bottom-0 w-[2px] h-full rounded-full bg-[#D7DFE9]"></div>
            )}
            <div className="absolute left-0 top-0.5 w-2.5 h-2.5 rounded-full bg-[#1DB469]"></div>

            <div className="flex items-center space-x-3">
              <span className="bg-gray-100 text-gray-700 text-xs font-medium px-2 py-1 text-[#5E718D] bg-[#F0F3F9] rounded capitalize">
                {val?.type}
              </span>
              <span className="text-[#C19C60] text-sm font-medium">
                {formatTime(val?.created_at)} - {formatDate(val?.created_at)}
              </span>
            </div>

            <p
              className={`text-sm text-[#455468] mt-1 pb-4 ${
                index !== logs?.length - 1 && "border-b border-[#E9EFF6]"
              }`}
            >
              {val?.logs} – by{" "}
              <span className="text-[#4A72FF] font-medium ">
                {val?.created_by_name}
              </span>
            </p>
          </div>
        ))}
      </div>

      <CustomPagination
        total={activityData?.data?.total || 0}
        limit={filter?.limit}
        page={page}
        handlePagination={handlePagination}
      />
    </>
  );
}
